<template>
  <div class="help">
    <header-nav :linkId="activeNum"></header-nav>
    <div class="drawer-bg" v-if="isShowDrawerBg" @click="handleDrawerBg" @touchmove="handleDrawerBg"></div>
    <div class="main" @touchmove="handleDrawerBg">
      <el-container>
        <el-aside :class="{'openSidebar': isUnfold, 'hideSidebar': !isUnfold, 'mobile': isMobile, 'menu-is-fixed': menuIsfixed && !isMobile, 'aside-menu': !menuIsfixed}">
          <div class="title-box" v-if="!isMobile" :class="{'mobile': !isMobile}"><h3 class="title">常见问题分类</h3></div>
          <el-menu :unique-opened="true" ref="menu" id="menu" default-active="1-1" @select="handleSelect">
            <div class="user-menu-box" v-for="menu in menus" :key="menu.id">
              <el-menu-item v-if="!menu.child" :index="menu.path">
                <span slot="title" v-text="menu.name" class="first-menu"></span>
              </el-menu-item>
              <el-submenu v-if="menu.child" :index="menu.path">
                <template slot="title">
                  <span slot="title" v-text="menu.name" class="first-menu" :class="{'is-active-child': childActive == menu.id}"></span>
                </template>
                <el-menu-item-group>
                  <el-menu-item v-for="subMenu in menu.child" :key="subMenu.id" v-text="subMenu.name" class="second-menu"
                    :index="subMenu.path" @click.native="handleSecondmenu(menu.id)"></el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </div>
          </el-menu>
        </el-aside>
        <el-container class="container" :class="{'mibole': isMobile}">
          <div class="title-box" v-if="isMobile"><i :class="{'el-icon-s-fold': isUnfold, 'el-icon-s-unfold': !isUnfold}" @click="handleUnfold"></i><h3 class="title">常见问题分类</h3></div>
          <div class="wrap">
            <div class="breadcrumb" :class="{'breadcrumb-is-fixed': breadcrumbIsFixed}">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
                <el-breadcrumb-item v-for="o in breadcrumbList" :key="o.id">{{o.name}}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div class="content">
              <h3 class="menu-title">{{menuTitle}}</h3>
              <ul class="">
                <li v-for="(item, index) in descInfo" :key="index">
                  <h4 class="title" v-if="item.title">{{item.title}}</h4>
                  <p class="sub-title" v-if="item.subTitle">{{item.subTitle}}</p>
                  <p class="txt" :class="{'text-indent': item.subTitle}">{{item.desc}}</p>
                  <p class="tip" v-if="item.tip">{{item.tip}}</p>
                  <div class="img-box" v-for="(img, index) in item.url" :key="index">
                    <img class="img" :src="img" />
                  </div>
                </li>
              </ul>

              <div class="preparing" v-show="isNoData">
                <img src="../assets/preparing.png" alt="" srcset="">
                <p class="tip">内容正在准备中...</p>
              </div>
            </div>
          </div>
          </el-container>
        </el-container>

    </div>
    <Footer></Footer>
  </div>
</template>

<script>
const img1 = require('../assets/help/img1.png')
const img2 = require('../assets/help/img2.png')
const img3 = require('../assets/help/img3.png')
const img4 = require('../assets/help/img4.png')
const img5 = require('../assets/help/img5.png')
const img6 = require('../assets/help/img6.png')
const img7 = require('../assets/help/img7.png')
const img8 = require('../assets/help/img8.png')
const img9 = require('../assets/help/img9.png')
const img10 = require('../assets/help/img10.png')
const img11 = require('../assets/help/img11.png')
const img12 = require('../assets/help/img12.png')
const img13 = require('../assets/help/img13.png')
const img14 = require('../assets/help/img14.png')
const img15 = require('../assets/help/img15.png')
const img16 = require('../assets/help/img16.png')
const img17 = require('../assets/help/img17.png')
const img18 = require('../assets/help/img18.png')
const img19 = require('../assets/help/img19.png')
const img20 = require('../assets/help/img20.png')
const img21 = require('../assets/help/img21.png')
const img22 = require('../assets/help/img22.png')
const img23 = require('../assets/help/img23.png')
const img24 = require('../assets/help/img24.png')
const img25 = require('../assets/help/img25.png')
const img26 = require('../assets/help/img26.png')
const img27 = require('../assets/help/img27.png')
const img28 = require('../assets/help/img28.png')
import headerNav from '../components/Header.vue'
import Footer from '../components/Footer.vue'
export default {
  name: 'Help',
  components: {
    headerNav,
    Footer
  },
  data() {
    return {
      isCollapse: true,
      activeNum: '4',
      clientHeight: '',
      activeMenu: '',
      indexBreadcrumbs: [],
      breadcrumbList: [],
      descInfo: [],
      breadcrumbIsFixed: false,
      menuIsfixed: false,
      isNoData: false,
      menuTitle: '',
      menus: [
        {
          id: '1',
          name: '商家入驻',
          path: '#1',
          child: [{
            id: '1-1',
            name: '平台注册',
            path: '1-1',
            info: [
              {
                desc: '进入注册页面。填写手机号、短信验证码、登录密码、企业名称、税号、企业地址、邀请码推荐人手机号。点击“立即注册”按钮提交注册',
                url: [img1]
              }, {
                desc: '登录完成后，点击导航栏“商户管理”下“我的商户”按钮，进入我的商户页面。填写基本信息',
                url: [img2]
              }, {
                desc: '我的商户页面。填写账户信息',
                url: [img3]
              }, {
                desc: '我的商户页面。上传资料图片信息。信息填写完后，点击“提交”按钮保存商户信息。',
                url: [img4]
              }
            ]
          }, {
            id: '1-2',
            name: '税局设置',
            path: '1-2',
            info: [
              {
                desc: '企业管理人员输入手机号/身份证、密码、手机动态码，实名登录电子税务局（https://etax.shenzhen.chinatax.gov.cn）',
                url: [img5]
              }, {
                desc: '选择企业办税-选择自己的身份-确认进入（企业法人、财务负责人才能申请开通）',
                url: [img6]
              }, {
                desc: '点击我要办税-选择发票使用',
                url: [img7]
              }, {
                desc: '拖动到底部-点击区块链电子发票申请（目前只有企业法人和财务负责人有资格进入）',
                url: [img8]
              }, {
                desc: '未开通状态，只有一个申请开通的按钮（目前只有白名单内的企业才有资格申请开通）',
                url: [img9, img10, img11]
              }, {
                desc: '已开通状态，显示出功能导航模块',
                url: [img12]
              }, {
                desc: '开通之后，企业需要选择开票模式才能进行开票，开票模式分为服务商代理模式和自主开票模式',
                url: [img13]
              }, {
                desc: '选择招行进行授权',
                url: [img14]
              }
            ]
          }, {
            id: '1-3',
            name: '税目设置',
            path: '1-3',
            info: [
              {
                desc: '提交保存商户信息后，页面会跳转税目设置页面。点击“添加”按钮进入添加税目页面',
                url: [img15]
              }, {
                desc: '进入添加税目页面，填写相关税目信息。点击“提交”按钮保存税目信息。',
                url: [img16]
              }, {
                desc: '保存后关闭当前弹窗，显示当前税目列表信息',
                url: [img17]
              }
            ]
          }]
        }, {
          id: '2',
          name: '开票',
          path: '#2',
          child: [{
            id: '2-1',
            name: '拍照小票开票',
            path: '2-1',
            info: [
              {
                title: '1、拍照小票开票（商家主动开票）',
                subTitle: '',
                desc: '拍照小票小票是指商户通过小程序或网页版商户后台，主动发起的开票。',
                url: []
              },
              {
                title: '2、开票方式',
                subTitle: '',
                desc: '商家主动开票有两种途径：小程序开票和PC端商户后台开票',
                url: []
              },
              {
                title: '2-1 小程序开票',
                subTitle: '2-1-1 自动开票',
                desc: '商家进入聚票通商家版小程序，选择右下角的“开票”--选择“订单匹配”--点击“开票”，即可完成开票。',
                url: [img20]
              },
              {
                title: '',
                subTitle: '2-1-2 手动录入',
                desc: '商家进入聚票通商家版小程序，选择右下角的“开票”--选择“手动录入”--“上传凭证”--点击“开票”，即可完成开票。',
                url: [img21]
              },
              {
                title: '2-2 网页版商户后台开票',
                subTitle: '2-2-1 审核开票',
                desc: '商家使用电脑进入聚票通商户后台，在“发票管理、审核开票”的发票列表中，点击操作栏的“审核开票”按钮--输入“开票信息”--“上传凭证”--点击“提交”，即可完成开票。',
                url: [img22]
              },
              {
                title: '',
                subTitle: '2-2-2 主动开票',
                desc: '商家使用电脑进入聚票通商户后台，在“发票管理、审核开票”的页面中，点击“主动开票”按钮--输入“开票信息”--“上传凭证”--点击“提交”，即可完成开票。',
                url: [img23]
              }
            ]
          }, {
            id: '2-2',
            name: '小票二维码开票',
            path: '2-2',
            info: [
              {
                title: '1、申请开票（扫描小票二维码）',
                subTitle: '',
                desc: '小票二维码开票是指用户在商店消费后，从商家处拿到消费小票，继而使用微信扫描小票上方的二维码后，在申请开票界面填写相应的信息，点击“申请开票”；',
                url: [img24]
              },
              {
                title: '2、查收发票方式',
                subTitle: '',
                desc: '收票方式有两种：公众号查收发票和邮箱查收发票。',
                url: []
              },
              {
                title: '',
                subTitle: '2-1 公众号查收发票',
                desc: '2-1-1 用户已关注聚票通公众号，在申请开票提交成功后，系统会提供直接进入聚票通公众号的二维码，您只需长按并识别二维码即可进入聚票通公众号查收发票。',
                url: [img25]
              },
              {
                title: '',
                subTitle: '',
                desc: ' 2-1-2 用户未关注聚票通公众号，在申请开票提交成功后，系统会提供含有聚票通公众号的二维码，您可长按并识别二维码并进入聚票通公众号查收发票。',
                url: [img26]
              },
              {
                title: '',
                subTitle: '',
                desc: ' 2-1-3 用户未关注聚票通公众号，在申请开票提交成功后的页面中，点击“完成”，并选择“关注公众号”，长按识别二维码并进入聚票通公众号查收发票。',
                url: [img27]
              },
              {
                title: '',
                subTitle: '2-2 邮箱查收发票',
                desc: '用户未关注聚票通公众号，在申请开票提交成功后的页面中，点击“完成”，并选择“发送邮箱”，填入收票邮箱地址即可；',
                tip: 'Tips：QQ邮箱已丢失发票，建议您使用其他邮箱。',
                url: [img28]
              }
            ]
          }, {
            id: '2-3',
            name: '支付后开票',
            path: '2-3',
            info: [
              {
                desc: '支付后开票指商家使用了我方提供的支付服务，用户在主动扫码支付后，可以在支付完成页面点击“申请开票”，填写开票抬头，实现自主开票。开票金额固定，与实际支付金额一致。',
                url: [img19]
              }
            ]
          }]
        }, {
          id: '3',
          name: '常见问题',
          path: '3'
        }, {
          id: '4',
          name: '发票作废',
          path: '4',
          info: [
            {
              desc: '在发票管理中选择发票红冲，选择需要红冲的发票，点击红冲即可作废发票',
              url: [img18]
            }
          ]
        }
      ],
      childActive: 0,
      isMobile: false,
      isUnfold: false,
      isShowDrawerBg: false
    }
  },
  mounted() {
    let that = this
    this.clientHeight = `${document.documentElement.clientHeight}` - 300
    window.onresize = function() {
      that.clientHeight =  `${document.documentElement.clientHeight}` - 300
    }

    if (this.menus[0].child) {
      this.breadcrumbList.push(this.menus[0], this.menus[0].child[0])
      this.descInfo = this.menus[0].child[0].info
      this.menuTitle = this.menus[0].child[0].name

    } else {
      this.breadcrumbList.push(this.menus[0])
      this.descInfo = this.menus[0].info
      this.menuTitle = this.menus[0].name
    }
    window.addEventListener('scroll', this.handleScroll)

    this.childActive = 1
    this.isMobile = this.UA().mobile
    this.isUnfold = this.isMobile ? false : true
  },
  methods: {
    handleDrawerBg () {
      this.isShowDrawerBg = false
      this.isUnfold = false
    },
    handleUnfold() {
      this.isUnfold = true
      this.isShowDrawerBg = true
    },
    handleSecondmenu(id) {
      this.childActive = id ? id : 0
      this.menuIsfixed = false
      this.isUnfold = false
      this.isShowDrawerBg = false
    },
    handleSelect (index, indexPath) {
      this.isUnfold = false
      this.isShowDrawerBg = false
      window.scrollTo(0, 0)
      this.breadcrumbList = []
      this.descInfo = []
      this.indexBreadcrumbs = indexPath
      let menuList = this.menus

      this.indexBreadcrumbs.map(item => {

        for (let i = 0; i < menuList.length; i++) {

          if (item === menuList[i].path) {
            this.breadcrumbList.push(menuList[i])
            this.descInfo = menuList[i].info
            this.menuTitle = menuList[i].name

            if (this.childActive != index) {
              this.childActive = 0
            }

            if (menuList[i].child) {
              menuList = menuList[i].child
              this.descInfo = menuList[i].info
            }

            this.isNoData = !this.descInfo ? true : false
            break
          }
        }
      })
    },
    handleScroll () {
      let scrollY = document.documentElement.scrollTop
      this.breadcrumbIsFixed = scrollY >= 30 ? true : false

      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight

      var menuHeight = document.getElementById('menu').offsetHeight + 170 + 288
      if (menuHeight >= windowHeight && !this.isMobile) {
        this.menuIsfixed = scrollTop >= scrollHeight - windowHeight - 172 ? true : false
      }

    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="less" scoped>
.help {
  .main {
    max-width: 12rem;
    margin: auto;
    position: relative;
  }
  .title-box {
    display: flex;
    align-items: center;
    i {
      font-size: .4rem;
      padding: 0 .16rem .2rem;
      color: #B71C22;
    }
    &.mobile {
      margin-left: .2rem;
    }
  }
  h3.title {
    margin-bottom: .2rem;
    font-size: .16rem;
    color: #666;
    text-align: left;
  }
  .drawer-bg {
    background: rgba(0, 0, 0, 0.3);
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 99;
    bottom: 0;

  }
  .el-aside {
    color: #333;
    z-index: 100;
    width: 2rem!important;
    overflow-x: hidden;
    &.mobile.openSidebar {
      transform: translate3d(0, 0, 0);
      transition: transform .28s, -webkit-transform .28s;
    }
    &.mobile.hideSidebar{
      transform: translate3d(-10rem, 0, 0);
      transition: transform .28s, -webkit-transform .28s;
    }
    &.aside-menu {
      position: fixed;
      top: 1.3rem;
      bottom: 0;
    }
    &.menu-is-fixed {
      position: absolute;
      bottom: 0;
    }
    .el-menu-item {
      color: #666;
      .first-menu {
        color: #303133;
      }
    }
    /deep/ .el-menu-item,
    /deep/ .el-submenu__title {
      height: .5rem!important;
      line-height: .5rem!important;
    }
    .second-menu {
      height: .32rem!important;
      line-height: .32rem!important;
      margin-bottom: .04rem;
      border-radius: .04rem;
    }
  }
  .el-menu {
    border-right: 0;
  }
  .is-active-child,
  /deep/ .is-active .el-submenu__title  i {
    color: #B71C22;
  }
  /deep/ .el-menu-item.is-active {
    .first-menu {
      color: #B71C22;
    }
  }
  /deep/ .el-menu-item:focus {
      background: transparent;
  }
  /deep/ .el-menu-item:hover,
  /deep/ .el-submenu__title:hover {
    color: #333;
    background: rgba(236,237,239,1);
  }
  .first-menu {
    font-size: .16rem;
  }
  .second-menu {
    font-size: .14rem;
    &.is-active {
      color: #333;
      background: rgba(236,237,239,1);
    }
  }
  .container {
    flex-direction: column;
    // min-height: 440px;
    margin-left: 2.4rem;
    position: relative;
    top: .6rem;
    z-index: 0;
    .wrap {
      padding: 0 .3rem;
      background:rgba(255,255,255,1);
      box-shadow:0px 0px .1rem 0px rgba(0, 0, 0, 0.1);
    }
    &.mibole {
      margin-left: 0;
    }
    .breadcrumb {
      padding: .3rem 0 .3rem;
      width: calc(100% - .68rem);
      position: absolute;
      z-index: 9999;
      background: #fff;
      -webkit-overflow-scrolling : touch;
      /deep/ .el-breadcrumb {
        padding-bottom: .12rem;
        border-bottom: 1px solid #d7d7d7;
        font-size: .16rem;
      }
      &.breadcrumb-is-fixed {
        -webkit-transform: translateZ(0);
        position: fixed;
        top: .7rem;
      }
    }
    .content {
      font-size: .16rem;
      color: #333;
      padding-top: .9rem;
      .menu-title {
        padding-bottom: .2rem;
        font-size: .24rem;
      }
      .title {
        font-weight: 600;
        margin-bottom: .04rem;
      }
      .sub-title {
        text-indent: 2em;
        padding-bottom: .1rem;
      }
      .txt {
        margin-bottom: .26rem;
        &.text-indent {
          text-indent: 2em;
        }
      }
      .img-box {
        margin: .2rem 0 .3rem;
        .img {
          max-width: 100%;
          &:not(:last-child) {
            margin-bottom: .1rem;
          }
        }
      }
      .tip {
        color: #7a869a;
        text-indent: 2em;
      }
    }
  }
  .preparing {
    text-align: center;
    padding: 1.6rem 0;
    .img {
      width: 2.27rem;
      height: 2.05rem;
    }
    .tip {
      margin-top: .18rem;
      color: #999;
    }
  }
}
@media (max-width: 768px) {
  .help {
    .el-aside {
      &.aside-menu {
        top: 0;
        height: 100%;
        width: 3rem!important;
      }
      .openSidebar {
        transform: translate3d(0, 0, 0);
        transition: transform .28s, -webkit-transform .28s;
      }
      .hideSidebar {
        transform: translate3d(-10rem, 0, 0);
        transition: transform .28s, -webkit-transform .28s;
      }
      .first-menu {
        font-size: .26rem;
      }
      .second-menu {
        font-size: .24rem;
      }
      .el-menu {
        height: 100%;
        padding-top: 1.2rem;
      }
      /deep/ .el-menu-item,
      /deep/ .el-submenu__title {
        height: .8rem!important;
        line-height: .8rem!important;
      }
      .second-menu {
        height: .6rem!important;
        line-height: .6rem!important;
        margin-bottom: .04rem;
        border-radius: .04rem;
      }
    }
    .main {
      .title {
        font-size: .3rem;
      }
    }
    .container {
      top: .4rem;
      .breadcrumb {
        .el-breadcrumb {
          font-size: .26rem;
        }
        &.breadcrumb-is-fixed {
          top: 1rem;
        }
      }
      .content {
        padding-top: 1rem;
        font-size: .24rem;
        .menu-title {
          font-size: .32rem;
        }
        .title {
          font-size: .28rem;
        }
      }
      .preparing {
        img {
          width: 2rem;
          height: 2rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/HelpCenter.vue